import React from "react";
import { Navigate } from "react-router-dom";

import { RootStore } from "store";
import { useAppSelector } from "store/hooks";

import { canManageIaqLimits } from "utils/helpers";
import { PAGES } from "utils/links";

interface RequireIaqLimitAccessProps {
  children: React.ReactElement;
}

export const RequireIaqLimitAccess: React.FC<RequireIaqLimitAccessProps> = ({ children }) => {
  const user = useAppSelector((state: RootStore) => state.auth.user);

  if (!canManageIaqLimits(user)) {
    return <Navigate to={PAGES.FORBIDDEN} replace />;
  }

  return children;
};
